import { loadFromFile } from "../../cad/formats/index"
import { createLogger } from "../../utils/logger"
import { sanitizeCadJson } from "../helpers/sanitize-cad-json.helper"

const logger = createLogger('cad-file.service')

/**
 * Parsea un archivo CAD (DXF/DWG) y devuelve el cadJson resultante.
 * El caller maneja la UI (loader/toasts) a través de los callbacks.
 *
 * @param {File}    file
 * @param {Object}  opts
 * @param {Function} opts.onProgress - (phase, size, total) => void
 *                                     phase: string fase del parser
 *                                     size:  bytes procesados
 *                                     total: bytes totales (puede ser 0 si desconocido)
 * @returns {Promise<Object>} cadJson parseado
 * @throws {Error} Si el parser falla. El mensaje viene del parser y suele ser apto para mostrar al usuario.
 */
export async function parseCadFile(file, { onProgress } = {}) {
  try {
    const cadJson = await loadFromFile(file, { progressCbk: onProgress })
    const rawCount = cadJson?.entities?.length ?? 0

    // Saneamiento — dos filtros aplicados en orden:
    //   1. polilíneas con vertex en (0,0)   → artefactos XREF/INSERT
    //   2. entities no-polilínea fuera del  → cajetines/fragmentos dispersos
    //      cluster del diseño + 50% margen
    //
    // Resultado: cadJson limpio que se propaga a admin viewer + .epcb cliente.
    const { cadJson: clean, removed, removedPolyArtifacts, removedOutsideCluster } = sanitizeCadJson(cadJson)
    const sanitizedNote = removed > 0
      ? ` (sanitized: -${removedPolyArtifacts} en origen, -${removedOutsideCluster} fuera del cluster)`
      : ''
    logger.info(`parsed cadJson — entities: ${rawCount}${sanitizedNote}`)
    return clean
  } catch (err) {
    logger.error('parse failed:', err)
    throw err   // re-throw para que el caller decida UI
  }
}
